@if (viewType() === 'normal') {
<div class="search-box {{ dropdownType() }} {{ searchType() }}">
  <div class="search-input-box border service" [ngClass]="{ show: dropdownType() === 'search' }">
    <button aria-label="Search"><img src="assets/images/search.svg" alt="" /></button>
    <input
      type="text"
      (click)="openDropdown('search')"
      placeholder="Modality"
      [(ngModel)]="serviceText"
      (input)="searchInput()" />
    <div class="search-service-pop">
      <div class="mobile-input">
        <button aria-label="Search"><img src="assets/images/search.svg" alt="" /></button>
        <input
          type="text"
          (click)="openDropdown('search')"
          placeholder="Modality"
          [(ngModel)]="serviceText"
          (input)="searchInput()" />
        <button>Cancel</button>
      </div>
      <div class="search-service-wrapper for-service">
        @if (filteredPopularCategories().length) {
        <div class="popular-services">
          <ul>
            @for (popular of filteredPopularCategories(); track popular) {
            <li
              tabindex="0"
              role="button"
              [innerHTML]="popular.name | highlight: getServiceText()"
              (click)="selectOption(popular.name, 'service')"
              (keydown.enter)="selectOption(popular.name, 'service')"
              (keydown.space)="selectOption(popular.name, 'service')"></li>
            }
          </ul>
        </div>
        }
      </div>
    </div>
  </div>
  @if (searchType() !== 'business') {
  <div class="search-input-box border location" [ngClass]="{ show: dropdownType() === 'location' }">
    <button aria-label="Location Pin"><img src="assets/images/pin.svg" alt="" /></button>
    <input
      type="text"
      id="location-input"
      #locationInput
      placeholder="Select a location"
      (focus)="locationFocus()"
      (blur)="locationFocusOut($event)"
      (input)="onLocationTextChanged($event)"
      (click)="openDropdown('location')" />
    @if (fetchingLocation()) {
    <i class="fa fa-spin fa-spinner fetching-loading"></i>
    }
    <div class="search-service-pop">
      <div class="mobile-input">
        <button aria-label="Location Pin"><img src="assets/images/pin.svg" alt="" /></button>
        <input
          type="text"
          id="location-input"
          #locationInput
          placeholder="Select a location"
          (input)="onLocationTextChanged($event)"
          (click)="openDropdown('location')" />
        <button>Cancel</button>
      </div>
      <div class="search-service-wrapper">
        <button class="current-location-btn" (click)="getmeraLocation()">
          <img src="assets/images/map-location-arrow.svg" alt="location" /> USE MY CURRENT LOCATION
        </button>
        <ul>
          @for (location of filteredLocationsList(); track location) {
          <li
            tabindex="0"
            role="button"
            (click)="selectLocation(location, true)"
            (keydown.enter)="selectLocation(location, true)"
            (keydown.space)="selectLocation(location, true)">
            {{ location.displayText }}
          </li>
          }
        </ul>
        <div class="online-section">
          <p>Looking for online telehealth? Select the button below for online appointments.</p>
          <button class="online-btn" (click)="changeToOnline()">
            <img src="assets/images/video.svg" alt="video" /> ONLINE AND TELEHEALTH APPOINTMENTS
          </button>
        </div>
      </div>
    </div>
  </div>
  }
  <div class="search-input-box calendar">
    <button aria-label="Calendar"><img src="assets/images/calendar.svg" alt="" /></button>
    <input
      placeholder="Today"
      [(ngModel)]="selectedDate"
      (click)="openDropdown('calendar'); calender.open()"
      (dateChange)="dateChanged($event)"
      [matDatepicker]="calender"
      [min]="minDate()" />
    <mat-datepicker #calender></mat-datepicker>
  </div>
  <button class="main-search" (click)="searchNow()">Search</button>
</div>
@if (pageType()) {
<div
  class="mob-search"
  tabindex="0"
  role="button"
  (click)="openMobilePop()"
  (keydown.enter)="openMobilePop()"
  (keydown.space)="openMobilePop()">
  <img class="search-icon" src="assets/images/search-outlined.svg" alt="search item" />
  <div class="content">
    <p class="service">
      {{ getServiceText() }} @if (locationText()) {
      <span>in {{ locationText() | slugText: 'capitalize' }}</span>
      }
    </p>
  </div>
</div>
} @if (!pageType()) {
<button aria-label="Search" class="mobile-search" (click)="openMobilePop()">
  Search for health and wellbeing <span><img src="assets/images/search.svg" alt="" /></span>
</button>
} } @if (viewType() === 'mobile' && getPageType()) { @if (isMobile()) {
<button class="simple-search arrow-btn" (click)="openMobilePop()">
  <i class="fa-solid fa-magnifying-glass"></i>
</button>
} @if (!isMobile()) {
<div class="mob-header">
  <div
    class="mob-search"
    [ngClass]="{ show: viewType() === 'mobile' }"
    tabindex="0"
    role="button"
    (click)="openMobilePop()"
    (keydown.enter)="openMobilePop()"
    (keydown.space)="openMobilePop()">
    <img class="search-icon" src="assets/images/search-outlined.svg" alt="search item" />
    <div class="content">
      <p class="service">
        {{ getServiceText() }} @if (locationText()) {
        <span>in {{ locationText() | slugText: 'capitalize' }}</span>
        }
      </p>
    </div>
  </div>
</div>
} }
